module.exports = __webpack_public_path__ + "static-v-shop/1784814111804/img/logo_visa.5f04499f.svg";